'use client';

import { AnimatePresence, motion } from 'framer-motion';

import useSettingStartPage from './useSettingStartPage';

import { SettingStartPageGuide } from '@/features/SettingStartPage';
import { useDeviceCheck } from '@/shared/hooks';
import { TRANSITION_VARIANTS } from '@/shared/constants';

const MobileSettingStartPage = () => {
  const { isVisible, browser, onClose } = useSettingStartPage();
  const { isDesktop } = useDeviceCheck();

  if (isDesktop) return null;

  if (!isVisible || browser === undefined) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={TRANSITION_VARIANTS['up']}
        transition={{
          damping: 20,
          stiffness: 100,
          type: 'spring',
          when: 'beforeChildren',
        }}
        className="fixed bottom-4 left-5 w-full"
      >
        <SettingStartPageGuide browser={browser} onClose={onClose} />
      </motion.div>
    </AnimatePresence>
  );
};

export default MobileSettingStartPage;
